export default __webpack_public_path__ + "static/media/WStore_FREEPlay.9c19e7a2.png";